import { generateCSVFileDownload } from 'core/utils';
import { pick, map, startCase, without } from 'lodash';
import { convertAmountAsPennies } from './financials-utils';
import { PAYMENT_TYPES_FORMATTED } from './types';

const NON_EXPORTABLE_COLUMNS = ['actions', 'action'];

export const buildCSVFileExport = (data, exportColumns, exportType, templateName = '') => {
  generateCSVFileDownload(buildCSVFileData(data, exportColumns, exportType, templateName));
}

export const buildCSVFileData = (data, exportColumns, exportType, templateName = '') => {
  const headers = exportColumns.map((col) => ({ label: col.label, key: col.value }));
  const targetKeys = headers.map((col) => col.key);
  const exportData = data
    .map((row) => pick(row, targetKeys))
    .map((row) => map(row, formatCell).join(','))
    .join('\n');
  const headeredData = headers.map((col) => `"${col.label}"`).join(',') + '\n' + exportData;
  const exportFilename = `${templateName !== '' ? templateName : exportType}_${new Date().toLocaleDateString('en-US').replace(/\//g,'')}`;

  return {
    fileData: headeredData,
    fileExtension: 'csv',
    fileName: exportFilename,
  };
}

export const columnsForExportModal = (columns) => {
  const filteredColumnKeys = without(Object.keys(columns), ...NON_EXPORTABLE_COLUMNS);
  return filteredColumnKeys.map((key) => {
    if (typeof columns[key].label !== 'string') {
      return { value: key, label: startCase(key) }
    }
    return { value: key, label: columns[key].label }
  });
}

const formatPaymentMethod = (method) => PAYMENT_TYPES_FORMATTED[method];
const formatDate = (date) => new Date(date).toLocaleDateString('en-US');

const SPECIAL_COLUMN_MAPPINGS = {
  paymentType: formatPaymentMethod,
  amountDue: convertAmountAsPennies,
  depositDate: formatDate,
  transactionDate: formatDate,
};

const formatCell = (val, key) => {
  if (val === null) {
    return '""';
  } else if (SPECIAL_COLUMN_MAPPINGS[key] !== undefined) {
    return `"${SPECIAL_COLUMN_MAPPINGS[key](val) || ''}"`;
  } else if (typeof val === 'number') {
    return `"${convertAmountAsPennies(val)}"`;
  } else {
    const tempString = PAYMENT_TYPES_FORMATTED[val] ? PAYMENT_TYPES_FORMATTED[val] : val;
    return `"${String(tempString).replaceAll(/"/g, '""')}"`;
  }
}

